export default "__VITE_ASSET__113c6734__"